import React, { useEffect } from "react";
import { auth } from "../../firebase";
import { useAuthState } from "react-firebase-hooks/auth";
import { useNavigate } from "react-router-dom";
import { LoadingCards } from "../../components/LoadingCards";

import SurgeryList from "./SurgeryList";

export const Home = () => {
  const [user, loading] = useAuthState(auth);
  const navigate = useNavigate();

  useEffect(() => {
    if (loading === false && user == null) {
      // Redirect to the login page if the user is not logged in
      navigate('/login');
    }
  }, [user, loading]);

  return (
    <div className="bg-gray-200 flex items-center h-screen w-screen flex-col">
      {loading ? (
        <div className="border border-gray-200 bg-white shadow rounded-md p-4 max-w-sm w-full mx-auto">
          <LoadingCards />
        </div>
      ) : user ? (
        <div>
          <SurgeryList />
          <div className="h-[200px] w-full"></div>
        </div>
      ) : null}
    </div>
  );
};
